
export class Str {
/**
 * Empty string constant.
 */
public static readonly EMPTY = '';
/**
 * Returns whether the given value is a string
 * @param {?} value
 * @return {?}
 */
public static isString(value: any): boolean {
    return typeof value === 'string';
  }
/**
 * Returns whether the given string is NOT an empty string.
 * @param {?} string
 * @return {?}
 */
public static isNotEmptyString(string: string): boolean {
    return string && string !== '';
  }
/**
 * Returns whether the given string is an empty string
 * @param {?} string
 * @return {?}
 */
public static isEmptyString(string: string): boolean {
    return !Str.isNotEmptyString(string);
  }
/**
 * Formats the given string by inserting tokens according to the
 * tokenized location of string indices, "{N}", in n-order.
 * @param {?} formatString
 * @param {...?} tokens
 * @return {?}
 */
public static stringFormat(formatString: string, ...tokens: (string | number)[]): string {
    if (!tokens || tokens.length === 0) {
      return formatString;
    }
    for (let /** @type {?} */ i = 0; i < tokens.length; i++) {
      formatString = formatString.replace(`{${i}}`, tokens[i] + '');
    }
    return formatString;
  }
}

function Str_tsickle_Closure_declarations() {
/**
 * Empty string constant.
 * @type {?}
 */
Str.EMPTY;
}
